export const isLogin = () => {
  if(checkCookie() === 'Osman') {
    return true
  } else {
    return false
  }
};

const getCookie = (cname) =>{
  let name = cname + "=";
  let ca = document.cookie.split(';');

  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const checkCookie = () => {
  const user = getCookie("applicationAuth");
    if(user && user !== ''){
      return user
    } else {
      return new Error('fail')
    }
}